import { AppWrapper, LoadingPage, withJob } from 'cleveron-web-components';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';

import { fetchUnreadReleaseNotes as fetchUnreadReleaseNotesAction } from '../../actions/collections/releaseNotes';
import { fetchVersion as fetchVersionAction } from '../../actions/version';
import { SC_CONNECTIONS_PATH } from '../../constants';
import usePermissions from '../../utils/usePermissions';
import ConnectedAppDrawer from '../ConnectedAppDrawer';
import { useMenuOptions } from '../MainMenu';
import Routes from '../Routes';

export function ConnectedAppWrapper({ id, fetchUnreadReleaseNotes }) {
    const collapsedState = localStorage.getItem('collapsed');
    const [collapsed, setCollapsed] = useState(collapsedState === 'true');
    const { canReadReleaseNotes } = usePermissions({
        canReadReleaseNotes: 'release_note_read',
    });

    useEffect(() => {
        localStorage.setItem('collapsed', collapsed);
    }, [collapsed, setCollapsed]);

    useEffect(() => {
        if (canReadReleaseNotes) {
            fetchUnreadReleaseNotes();
        }
    }, [canReadReleaseNotes, fetchUnreadReleaseNotes]);

    const { links } = useMenuOptions();
    const hideMainMenu = links.length === 1 && links[0].path === `/${SC_CONNECTIONS_PATH}`;

    return (
        <AppWrapper
            ConnectedAppDrawer={ConnectedAppDrawer}
            collapsed={collapsed}
            drawer
            hideMainMenu={hideMainMenu}
            id={id}
            toggleCollapsed={() => setCollapsed(!collapsed)}
        >
            <Routes id={`${id}Route`} />
        </AppWrapper>
    );
}

const mapStateToProps = state => ({ version: state.version });

const mapDispatchToProps = dispatch =>
    bindActionCreators({ fetchVersion: fetchVersionAction }, dispatch);

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    withJob({
        LoadingComponent: ({ id }) => <LoadingPage id={`${id}Loading`} />,
        work: ({ fetchVersion, version }) => !version && Promise.all([fetchVersion()]),
    })
)(
    connect(null, dispatch =>
        bindActionCreators({ fetchUnreadReleaseNotes: fetchUnreadReleaseNotesAction }, dispatch)
    )(ConnectedAppWrapper)
);
